import { IconCheckWithCircle } from '@/blocks/components/Icons/IconCheckWithCircle';
import { IconWarning } from '@/blocks/components/Icons/IconWarning';
import styles from './modalStyles.module.scss';
import typography from '@/styles/typography.module.scss';
import React from 'react';
import { IconCross } from '@/blocks/components/Icons';
import classNames from 'classnames';

type Props = {
  onClose: () => void;
  modalTitle: React.ReactNode;
  modalSubtitle: React.ReactNode;
  errorStyle?: boolean;
};

const ModalComplaints = ({ onClose, modalTitle, modalSubtitle, errorStyle = false }: Props) => {
  return (
    <div className={classNames(styles.modal, errorStyle ? styles.errorStyles : styles.success)}>
      <div className={styles.iconModal}>{errorStyle ? <IconWarning /> : <IconCheckWithCircle />}</div>
      <div className={styles.modalContent}>
        <div className={styles.modalInfo}>
          <p className={typography.bodyS}>{modalTitle}</p>
          <button className={styles.iconWrapper} onClick={onClose}>
            <IconCross />
          </button>
        </div>
        <p className={typography.bodyS}>{modalSubtitle}</p>
      </div>
    </div>
  );
};

export default ModalComplaints;
